import { render, staticRenderFns } from "./ChooseActive.vue?vue&type=template&id=e4189f4e&scoped=true&"
import script from "./ChooseActive.vue?vue&type=script&lang=js&"
export * from "./ChooseActive.vue?vue&type=script&lang=js&"
import style0 from "./ChooseActive.vue?vue&type=style&index=0&id=e4189f4e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4189f4e",
  null
  
)

export default component.exports